import React, { useEffect, useState } from "react";
import {
  GridTextFieldForm,
  GridDatePickerForm as DatePickerForm,
  DropDownProps,
  DropDown
} from "@toorak/tc-common-fe-sdk";
import {
  GridTextFieldProps as TextFieldProps,
  DatePickerProps
} from "./FormComponentsProps";

export const GenericSummaryTextField = (props: TextFieldProps) => {
  const {
    value,
    onChange,
    error,
    helperText,
    isViewMode,
    onBlur,
    label,
    infoIconData,
    editedLabel,
    defaultValue,
    fromSummary,
    viewModeStyle,
    editedData,
    isServicerMandatory,
    enableReason,
    onReasonBlur,
    showEditedTag,
    onHover
  } = props;
  const [newEditedData, setNewEditedData] = useState<any>([]);

  useEffect(() => {
    if (editedData && editedData.length > 0) {
      const data = editedData.map((item: any) => {
        if (item.comments === "value recalculated") {
          return { ...item, updatedBy: "System Re-Calculated" };
        }
        return item;
      });
      setNewEditedData(data);
    }
  }, [editedData]);

  return (
    <GridTextFieldForm
      // required
      value={value}
      isViewMode={isViewMode}
      onChange={onChange}
      label={label}
      error={error}
      helperText={helperText}
      data-testid="borrowing-entity"
      valueTestId="borrower-entity-value"
      onBlur={onBlur}
      // editedData={editedData}
      editedData={newEditedData}
      infoIconData={infoIconData}
      editedLabel={editedLabel}
      defaultValue={defaultValue}
      fromSummary={fromSummary}
      viewModeStyle={viewModeStyle}
      isServicerMandatory={isServicerMandatory}
      enableReason={enableReason ?? false}
      onReasonBlur={onReasonBlur}
      showEditedTag={showEditedTag}
      onHover={onHover}
    />
  );
};

export const GridSummaryDateField = (props: DatePickerProps) => {
  const {
    value,
    onChange,
    error,
    helperText,
    isViewMode,
    onBlur,
    editedLabel,
    infoIconData,
    label,
    onReasonBlur,
    showEditedTag,
    onHover,
    enableReason,
    editedData
  } = props;

  return (
    <div style={{width: "100%", paddingTop: "4px"}}>
      <DatePickerForm
        value={(isViewMode ? (value ? `${value}` : "") : value) as any}
        onChange={onChange as any}
        isViewMode={isViewMode}
        label={label}
        error={error}
        helperText={helperText}
        infoIconData={infoIconData}
        onBlur={onBlur}
        editedLabel={editedLabel}
        onReasonBlur={onReasonBlur}
        showEditedTag={showEditedTag}
        onHover={onHover}
        enableReason={enableReason}
        editedData={editedData}
        // renderInput={(props: any) => (
        //   <CustomizedTextField
        //     props={props}
        //     data-testid={"original-credit-report-date"}
        //     value={value}
        //     error={error}
        //     helperText={helperText}
        //     isViewMode={isViewMode}
        //     valueTestId={"original-credit-report-date-value"}
        //   />
        // )}
      />
    </div>
  );
};

export const GenericSummaryDropDown = (props: DropDownProps) => {
  const {
    selectionValue,
    selectionOnChange,
    selectionData,
    helperText,
    isViewMode,
    editedLabel,
    formControlTestId,
    inputLabelId,
    inputLabelTestId,
    label,
    selectId,
    selectTestId,
    infoIconData,
    editedData,
    isLATView,
    onBlur,
    enableReason,
    notRequired = false,
    menuItemStyles,
    renderCustomInfoTag,
    showEditedTag,
    onHover,
    onReasonBlur
  } = props;
  return (
    <DropDown
      isViewMode={isViewMode}
      formControlTestId={formControlTestId}
      inputLabelId={inputLabelId}
      inputLabelTestId={inputLabelTestId}
      label={label}
      selectId={selectId}
      selectTestId={selectTestId}
      selectionValue={selectionValue}
      selectionOnChange={selectionOnChange}
      selectionData={selectionData}
      helperText={helperText}
      onBlur={onBlur}
      infoIconData={infoIconData}
      valueTestId="borrower-type-value"
      editedLabel={editedLabel}
      editedData={editedData}
      isLATView={isLATView}
      enableReason={enableReason}
      notRequired={notRequired}
      menuItemStyles={menuItemStyles}
      renderCustomInfoTag={renderCustomInfoTag}
      showEditedTag={showEditedTag}
      onHover={onHover}
      onReasonBlur={onReasonBlur}
    />
  );
};
